export default __webpack_public_path__ + "4cb4464e578f2cbae2e672ce7bec3133.svg";